import { Box, Typography } from "@mui/material";
import { ErrorMessage, Field,useFormikContext } from "formik";
import React from "react";
import TextError from "../TextError";
import { useState,useEffect } from "react";

const FormikSelect = (props) => {
  let {
    label,
    arrind,
    setPdata,
    name,
    validation,
    readOnly,
    options,
    parentname,
    arrayIndex,
    errors,
    setProposer,
    arrayHelpers,
    arrayvalues,
    ...rest
  } = props;

  //console.log(arrayIndex,"......")
  const [subOcupationOptions,setSubOcupationOptions] = useState([])

  const formContext = useFormikContext()

  useEffect(() => {
    
    if (name === `primaryDetails.Family[${arrayIndex}].Status`) {
     // console.log('contexc',formContext.values.primaryDetails.Family[`${arrayIndex}`].Status)
      if (formContext.values.primaryDetails.Family[`${arrayIndex}`].Status === '901') {
        document.getElementById(`primaryDetails.Family[${arrayIndex}].DeathReason`).closest('div').closest('.mb-3').setAttribute('hidden', true)
        document.getElementById(`primaryDetails.Family[${arrayIndex}].DateofDeath`).closest('div').closest('.mb-3').setAttribute('hidden', true)
        document.getElementById(`primaryDetails.Family[${arrayIndex}].HealthStatus`).closest('div').closest('.mb-3').removeAttribute('hidden')
        formContext.setFieldValue(`primaryDetails.Family[${arrayIndex}].HealthStatus`,formContext.values.primaryDetails.Family[`${arrayIndex}`].HealthStatus)
        formContext.setFieldValue(`primaryDetails.Family[${arrayIndex}].DateofDeath`,'null')
        formContext.setFieldValue(`primaryDetails.Family[${arrayIndex}].DeathReason`,'null')


      }else if (formContext.values.primaryDetails.Family[`${arrayIndex}`].Status === ''){
       // console.log('empty')
        document.getElementById(`primaryDetails.Family[${arrayIndex}].DeathReason`).closest('div').closest('.mb-3').setAttribute('hidden', true)
        document.getElementById(`primaryDetails.Family[${arrayIndex}].DateofDeath`).closest('div').closest('.mb-3').setAttribute('hidden', true)
        document.getElementById(`primaryDetails.Family[${arrayIndex}].HealthStatus`).closest('div').closest('.mb-3').removeAttribute('hidden')
        formContext.setFieldValue(`primaryDetails.Family[${arrayIndex}].HealthStatus`,formContext.values[`primaryDetails.Family[${arrayIndex}].HealthStatus`])
      }else {
        document.getElementById(`primaryDetails.Family[${arrayIndex}].DeathReason`).closest('.mb-3').removeAttribute('hidden')
        document.getElementById(`primaryDetails.Family[${arrayIndex}].DateofDeath`).closest('.mb-3').removeAttribute('hidden')
        document.getElementById(`primaryDetails.Family[${arrayIndex}].HealthStatus`).closest('div').closest('.mb-3').setAttribute('hidden',true)
        formContext.setFieldValue(`primaryDetails.Family[${arrayIndex}].HealthStatus`,"null")

      }
    }

    if (name === 'primaryDetails.LifeAssured.Nationality') {
      if (formContext.values.primaryDetails.LifeAssured.Nationality === '501') {
        document.getElementById('primaryDetails.LifeAssured.NRI_Country').closest('div').closest('.mb-3').setAttribute('hidden', true)
        formContext.setFieldValue('primaryDetails.LifeAssured.NRI_Country', 'null')
      } else {
        formContext.setFieldValue('primaryDetails.LifeAssured.NRI_Country', formContext.values.primaryDetails.LifeAssured.Nationality )
        document.getElementById('primaryDetails.LifeAssured.NRI_Country').closest('div').closest('.mb-3').removeAttribute('hidden')

      }
    }
    
    if(name === 'primaryDetails.LifeType'){
      if(formContext.values.primaryDetails.LifeType ==='S'){
        if(document.getElementById('primaryDetails.Documents[0].ProposerIDProof') !== null

        ){
          document.getElementById('primaryDetails.Documents[0].ProposerIDProof').closest('div').closest('.mb-3').setAttribute('hidden', true)
          document.getElementById('primaryDetails.Documents[0].ProposerPhoto').closest('div').closest('.mb-3').setAttribute('hidden', true)
          formContext.setFieldValue('primaryDetails.Documents[0].ProposerIDProof.ProofName', 'null')
          formContext.setFieldValue('primaryDetails.Documents[0].ProposerPhoto.ProofName', 'null')
        }
        
      }else{
        if(document.getElementById('primaryDetails.Documents[0].ProposerIDProof') !== null
       // &&  document.getElementById('primaryDetails.Documents[0].ProposerPhoto') !==null
        ){
          document.getElementById('primaryDetails.Documents[0].ProposerIDProof').closest('div').closest('.mb-3').removeAttribute('hidden')
          document.getElementById('primaryDetails.Documents[0].ProposerPhoto').closest('div').closest('.mb-3').removeAttribute('hidden')
          formContext.setFieldValue('primaryDetails.Documents[0].ProposerIDProof.ProofName', '')
          formContext.setFieldValue('primaryDetails.Documents[0].ProposerPhoto.ProofName', '')
        }
        
      }
    }

    if(name === "primaryDetails.LifeAssured.SubOccupation" 
    && formContext.values.primaryDetails.LifeAssured.Occupation != ""
    ){

      if(formContext.values.primaryDetails.LifeAssured.Occupation === '840'){
       // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
       let filterOptions=[]
        filterOptions = options.filter(option=> option.value === '44'|| option.value === '' && option)
        setSubOcupationOptions(filterOptions)
        console.log('ocup',options)
      }else if(formContext.values.primaryDetails.LifeAssured.Occupation === '844'){
        // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
        let filterOptions=[]
         filterOptions = options.filter(option=> option.value === '40'|| option.value === '' && option)
         setSubOcupationOptions(filterOptions)
         console.log('ocup',options)
      }else if(formContext.values.primaryDetails.LifeAssured.Occupation === '837'){
        // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
        let filterOptions=[]
         filterOptions = options.filter(option=> option.value === '43'|| option.value === '' && option)
         setSubOcupationOptions(filterOptions)
         console.log('ocup',options)
       }else if(formContext.values.primaryDetails.LifeAssured.Occupation === '842'){
        // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
        let filterOptions=[]
         filterOptions = options.filter(option=> option.value === '42'|| option.value === '' || 
         option.value === '20'|| option.value === '19' && option)
         setSubOcupationOptions(filterOptions)
         console.log('ocup',options)
       }else if(formContext.values.primaryDetails.LifeAssured.Occupation === '847'){
        // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
        let filterOptions=[]
         filterOptions = options.filter(option=> option.value === '46'|| option.value === '' 
          && option)
         setSubOcupationOptions(filterOptions)
         console.log('ocup',options)
       }else if(formContext.values.primaryDetails.LifeAssured.Occupation === '841'){
        // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
        let filterOptions=[]
         filterOptions = options.filter(option=> option.value === '33'|| option.value === '' || 
         option.value === '31'|| option.value === '11' || option.value === '48' || option.value === '36'
         || option.value === '34' || option.value === '37' || option.value === '32' || option.value === '30'
         || option.value === '35' || option.value === '16' || option.value === '29' || option.value === '18'
         || option.value === '38' && option)
         setSubOcupationOptions(filterOptions)
         console.log('ocup',options)
       }else if(formContext.values.primaryDetails.LifeAssured.Occupation === '848'){
        // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
        let filterOptions=[]
         filterOptions = options.filter(option=> option.value === '47'|| option.value === '' 
          && option)
         setSubOcupationOptions(filterOptions)
         console.log('ocup',options)
       }else if(formContext.values.primaryDetails.LifeAssured.Occupation === '846'){
        // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
        let filterOptions=[]
         filterOptions = options.filter(option=> option.value === '28'|| option.value === '' 
          && option)
         setSubOcupationOptions(filterOptions)
         console.log('ocup',options)
       }else if(formContext.values.primaryDetails.LifeAssured.Occupation === '843'){
        // console.log('ocup',options,formContext.values.primaryDetails.LifeAssured.Occupation)
        let filterOptions=[]
         filterOptions = options.filter(option=> option.value === '21'|| option.value === '' 
        || option.value === '22' || option.value === '26'  || option.value === '23' || option.value === '24' 
        || option.value === '49' || option.value === '25' || option.value === '39' || option.value === '27'  && option)
         setSubOcupationOptions(filterOptions)
         console.log('ocup',options)
       }else{
        setSubOcupationOptions(options)

       }

    }

  }, [
    formContext.values.primaryDetails !== undefined &&formContext.values.primaryDetails.LifeAssured !== undefined 
    && formContext.values.primaryDetails.LifeAssured.Occupation 
  ])
  

  return (
    <div>
      <div>
        <Typography>{label}</Typography>

        <Field name={name}>
          {({ form, field }) => {
            const { setFieldValue, values, setFieldError } = form;

            var prevalue = 0;
            var selvalue = [];

            if(name==="PremiumTerm"){
              if(values.PolicyTerm==='10'){
                // options.pop()
                options=[
                  {value: '', label: 'Select Term'},
                  {value: 8, label: '8 years'},
                  {value: 10, label: '10 years'}
                ]

              }
              //console.log(options,values,"options..")
            }
            /* else if(name==="PolicyTerm"){
              if(parseInt(values.PremiumTerm)===10){
                options=[
                  {value: '', label: 'Select Term'},
                 {value: 10, label: '10 years'}
                ]
              }
            } */

            const handleChange = (val) => {

              /*  if(val.target.value==="901"){
                 const elem=document.getElementById(`Family[${arrind}]`)
                 const childs=elem.childNodes
                 for(let i=0;i<childs.length;i++){
                   if(childs[i].id==="DateofDeath" || childs[i].id==="DeathReason" || childs[i].id==="AgeatDeath"){
                     childs[i].setAttribute("hidden", true);
                   }
                   else if(childs[i].id==="age"){
                     childs[i].removeAttribute("hidden");
                     console.log(`${parentname}.${childs[i].id}`,"childname")
                     setFieldError(`${parentname}.${childs[i].id}`,"required")
                   }
                 }
             }
             else if(val.target.value==="902"){
               const elem=document.getElementById(`Family[${arrind}]`)
               const childs=elem.childNodes
               for(let i=0;i<childs.length;i++){
                 if(childs[i].id==="DateofDeath" || childs[i].id==="DeathReason" || childs[i].id==="AgeatDeath"){
                   childs[i].removeAttribute("hidden");
                   // console.log(`${parentname}.${childs[i].id}`,"childname")
                   setFieldError(`${parentname}.${childs[i].id}`,"required")
                 }
                 else if(childs[i].id==="age"){
                   childs[i].setAttribute("hidden",true);
                 }
               }
             }else if(val.target.value==="S"){
               setPdata(true)
             }else if(val.target.value==="O"){
               setPdata(false)
             } */

             if (name === `primaryDetails.Family[${arrayIndex}].Status`) {
              
              if (val.target.value === '901') {
                document.getElementById(`primaryDetails.Family[${arrayIndex}].DeathReason`).closest('div').closest('.mb-3').setAttribute('hidden', true)
                document.getElementById(`primaryDetails.Family[${arrayIndex}].DateofDeath`).closest('div').closest('.mb-3').setAttribute('hidden', true)
                document.getElementById(`primaryDetails.Family[${arrayIndex}].HealthStatus`).closest('div').closest('.mb-3').removeAttribute('hidden')
                setFieldValue(`primaryDetails.Family[${arrayIndex}].HealthStatus`,"")
                setFieldValue(`primaryDetails.Family[${arrayIndex}].DateofDeath`,'null')
                setFieldValue(`primaryDetails.Family[${arrayIndex}].DeathReason`,'null')

              }else if (val.target.value === '') {
                document.getElementById(`primaryDetails.Family[${arrayIndex}].DeathReason`).closest('div').closest('.mb-3').setAttribute('hidden', true)
                document.getElementById(`primaryDetails.Family[${arrayIndex}].DateofDeath`).closest('div').closest('.mb-3').setAttribute('hidden', true)
                document.getElementById(`primaryDetails.Family[${arrayIndex}].HealthStatus`).closest('div').closest('.mb-3').removeAttribute('hidden')
                setFieldValue(`primaryDetails.Family[${arrayIndex}].HealthStatus`,"")
                setFieldValue(`primaryDetails.Family[${arrayIndex}].DateofDeath`,'')
                setFieldValue(`primaryDetails.Family[${arrayIndex}].DeathReason`,'')

              } else {
                document.getElementById(`primaryDetails.Family[${arrayIndex}].DeathReason`).closest('.mb-3').removeAttribute('hidden')
                document.getElementById(`primaryDetails.Family[${arrayIndex}].DateofDeath`).closest('.mb-3').removeAttribute('hidden')
                document.getElementById(`primaryDetails.Family[${arrayIndex}].HealthStatus`).closest('div').closest('.mb-3').setAttribute('hidden',true)
                setFieldValue(`primaryDetails.Family[${arrayIndex}].HealthStatus`,"null")
                setFieldValue(`primaryDetails.Family[${arrayIndex}].DateofDeath`,'')
                setFieldValue(`primaryDetails.Family[${arrayIndex}].DeathReason`,'')

              }
            }

              if (name === 'primaryDetails.LifeAssured.Nationality') {
                if (val.target.value === '501') {
                  document.getElementById('primaryDetails.LifeAssured.NRI_Country').closest('div').closest('.mb-3').setAttribute('hidden', true)
                  setFieldValue('primaryDetails.LifeAssured.NRI_Country', 'null')
                } else {
                  setFieldValue('primaryDetails.LifeAssured.NRI_Country', '')
                  document.getElementById('primaryDetails.LifeAssured.NRI_Country').closest('div').closest('.mb-3').removeAttribute('hidden')

                }
              }

             
              if (name === "primaryDetails.LifeAssured.Occupation") {
                //console.log('gsg', val.target.value)
                setFieldValue("Proposer.Occupation", val.target.value);
                if (val.target.value === "837") {
                  setFieldValue('primaryDetails.LifeAssured.HusbandOccupation','')
                  setFieldValue('primaryDetails.LifeAssured.HusbandAnnualIncome','')
                  setFieldValue('primaryDetails.LifeAssured.HusbandInsuranceDetails','')

                  document.getElementById('primaryDetails.LifeAssured.HusbandOccupation').closest('.mb-3').removeAttribute('hidden')
                  document.getElementById('primaryDetails.LifeAssured.HusbandAnnualIncome').closest('.mb-3').removeAttribute('hidden')
                  document.getElementById('primaryDetails.LifeAssured.HusbandInsuranceDetails').closest('.mb-3').removeAttribute('hidden')
                }else{
                  setFieldValue('primaryDetails.LifeAssured.HusbandOccupation','null')
                  setFieldValue('primaryDetails.LifeAssured.HusbandAnnualIncome','0')
                  setFieldValue('primaryDetails.LifeAssured.HusbandInsuranceDetails','0')
                  document.getElementById('primaryDetails.LifeAssured.HusbandOccupation').closest('div').closest('.mb-3').setAttribute('hidden', true)
                  document.getElementById('primaryDetails.LifeAssured.HusbandAnnualIncome').closest('div').closest('.mb-3').setAttribute('hidden', true)
                  document.getElementById('primaryDetails.LifeAssured.HusbandInsuranceDetails').closest('div').closest('.mb-3').setAttribute('hidden', true)

                }

              }
              if(name==="primaryDetails.LifeAssured.Title"){
                //console.log("value...",val.target.value)
                if(val.target.value==="971"){
                     setFieldValue("primaryDetails.LifeAssured.Gender","M")
                }else if(val.target.value==="972"||val.target.value==="974"||val.target.value==="975"){
                  setFieldValue("primaryDetails.LifeAssured.Gender","F")
                }else{
                  setFieldValue("primaryDetails.LifeAssured.Gender","") 
                }
                //setFieldValue("Proposer.Title", val.target.value);
              }
              if(name==="Proposer.Title"){
                //console.log("value...",val.target.value)
                if(val.target.value==="971"){
                     setFieldValue("Proposer.Gender","M")
                }else if(val.target.value==="972"||val.target.value==="974"||val.target.value==="975"){
                  setFieldValue("Proposer.Gender","F")
                }else{
                  setFieldValue("Proposer.Gender","") 
                }
              }
              if(name===`nomineeDetails[${arrayIndex}].Title`){
                //console.log("value...",val.target.value)
                if(val.target.value==="971"){
                     setFieldValue(`nomineeDetails[${arrayIndex}].NomineeGender`,"M")
                }else if(val.target.value==="972"||val.target.value==="974"||val.target.value==="975"){
                  setFieldValue(`nomineeDetails[${arrayIndex}].NomineeGender`,"F")
                }else{
                  setFieldValue(`nomineeDetails[${arrayIndex}].NomineeGender`,"") 
                }
              }

              if(name === 'primaryDetails.LifeType'){
                //console.log('select',val.target.value)
                if(val.target.value ==='S'){
        if(document.getElementById('primaryDetails.Documents[0].ProposerIDProof')!== null){
          document.getElementById('primaryDetails.Documents[0].ProposerIDProof').closest('div').closest('.mb-3').setAttribute('hidden', true)
          document.getElementById('primaryDetails.Documents[0].ProposerPhoto').closest('div').closest('.mb-3').setAttribute('hidden', true)
          setFieldValue('primaryDetails.Documents[0].ProposerIDProof.ProofName', 'null')
          setFieldValue('primaryDetails.Documents[0].ProposerPhoto.ProofName', 'null')
        }
                 

                }else{
        if(document.getElementById('primaryDetails.Documents[0].ProposerIDProof') !== null){
          document.getElementById('primaryDetails.Documents[0].ProposerIDProof').closest('div').closest('.mb-3').removeAttribute('hidden')
          document.getElementById('primaryDetails.Documents[0].ProposerPhoto').closest('div').closest('.mb-3').removeAttribute('hidden')
          setFieldValue('primaryDetails.Documents[0].ProposerIDProof.ProofName', '')
          setFieldValue('primaryDetails.Documents[0].ProposerPhoto.ProofName', '')
        }
                 

                }
              }

            
            setFieldValue(name, val.target.value);
          };

          return (
          <>
            {readOnly !== undefined ? (
              <Field
                as="select"
                id={name}
                name={name}
                disabled={Boolean(readOnly)}
                {...rest}
                placeholder="select"
                className="form-select mb-3 form-control"
                onChange={(val) => handleChange(val, name)}
              >
                {options.map((option) => {
                  return (
                    <option key={option.value} value={option.value} className="h6">
                      {option.label}
                    </option>
                  );
                })}
              </Field>
            ) : (
              <Field
                as="select"
                id={name}
                name={name}
                {...rest}
                placeholder="select"
                className="form-select mb-3 form-control"
                onChange={(val) => handleChange(val, selvalue)}
              >
                {
                name === "primaryDetails.LifeAssured.SubOccupation" ?
                (subOcupationOptions.map((option) => {
                  return (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  );
                }))
                :options.map((option) => {
                  return (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  );
                })}
              </Field>
            )}
          </>
          );
          }}
        </Field>
        <ErrorMessage name={name} component={TextError}></ErrorMessage>
      </div>
    </div>
  );
};

export default FormikSelect;
